import "./Home.css";
// import GitHubCalendar from "react-github-calendar";
function Home() {
  return (
    <div className="HomeContainer">
      <div className="HomeFlex">
        <div className="HomeRow1">

          <p className="text14pxnormal">Let's Build Something Together</p>
          <span>
          <span className="text50pxbold">
            Hi, I'm <span className="violet">Tanisha Rao</span>
          </span>{" "}
          <p className="text45pxbold">A Full Stack Web Developer</p>
          </span>
          <p className="text16pxnormal">
            I'm focused on building responsive front-end web applications while
            learning back-end technologies.
          </p>
          <button
            className="VioletBtn"
            onClick={() =>
              window.open(
                "https://mail.google.com/mail/?view=cm&fs=1&to=tanisharao810@gmail.com&su=Let's Work Together&body=Hi! I came across your portfolio and would like to discuss...",
                "_blank"
              )
            }
          >
            Reach Out!
          </button>
        </div>
        {/* <div className="chart1">
          <p className="text22pxnormal fontStyle1">My Programming Garden</p>
          <img
            src="https://ghchart.rshah.org/7c46e1/tanisharao2002"
            alt="GitHub Contributions"
            className="chart-container"
          />
        </div> */}
      </div>
    </div>
  );
}

export default Home;
